/* <clic-scroll-arrows data-target=".selector">
 *
 * Prev/next arrow buttons for the theme's NATIVE horizontal scroll rows —
 * the desktop companion to <clic-scroll-dots> (which covers phones). Used
 * where a plain overflow-x container hides its scrollbar and needs a click
 * affordance instead (e.g. .clic-features__grid desktop scroll).
 *
 * - data-target: selector for the scroll container, resolved within the
 *   closest .shopify-section (falls back to the previous element sibling).
 * - Renders two overlay buttons; each click scrolls by one item stride
 *   (the offset between consecutive items, so gaps are included).
 * - Buttons disable at either end; the element hides itself entirely when
 *   the container doesn't overflow and re-checks on resize. Positioning and
 *   the >=768px gate live in clic-scroll-arrows.css — the parent must be a
 *   positioned box spanning the scroll row.
 */
(function () {
  'use strict';
  if (customElements.get('clic-scroll-arrows')) return;

  var CHEVRON =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="9 5 16 12 9 19"/></svg>';

  customElements.define(
    'clic-scroll-arrows',
    class extends HTMLElement {
      connectedCallback() {
        var scope = this.closest('.shopify-section') || document;
        this.target = this.dataset.target
          ? scope.querySelector(this.dataset.target)
          : this.previousElementSibling;
        if (!this.target) return;

        this.onScroll = this.onScroll.bind(this);
        this.refresh = this.refresh.bind(this);
        this.ticking = false;

        this.prevBtn = this.buildButton('prev');
        this.nextBtn = this.buildButton('next');
        this.appendChild(this.prevBtn);
        this.appendChild(this.nextBtn);

        this.target.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.refresh);
        document.addEventListener('theme:resize:width', this.refresh);
        this.refresh();
      }

      disconnectedCallback() {
        if (this.target) this.target.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.refresh);
        document.removeEventListener('theme:resize:width', this.refresh);
      }

      buildButton(dir) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'clic-scroll-arrows__btn clic-scroll-arrows__btn--' + dir;
        btn.setAttribute('aria-label', dir === 'prev' ? 'Scroll back' : 'Scroll forward');
        btn.innerHTML = CHEVRON;
        btn.addEventListener('click', this.scrollStep.bind(this, dir === 'prev' ? -1 : 1));
        return btn;
      }

      items() {
        return Array.prototype.filter.call(this.target.children, function (el) {
          return el.offsetParent !== null;
        });
      }

      // One item's stride (width + gap); page-width fallback for single items.
      stride() {
        var kids = this.items();
        if (kids.length > 1) return kids[1].offsetLeft - kids[0].offsetLeft;
        return this.target.clientWidth * 0.8;
      }

      scrollStep(direction) {
        this.target.scrollBy({ left: this.stride() * direction, behavior: 'smooth' });
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        var self = this;
        requestAnimationFrame(function () {
          self.ticking = false;
          self.updateState();
        });
      }

      refresh() {
        var t = this.target;
        // No overflow → nothing to navigate.
        if (this.items().length < 2 || t.scrollWidth <= t.clientWidth + 4) {
          this.hidden = true;
          return;
        }
        this.hidden = false;
        this.updateState();
      }

      updateState() {
        var t = this.target;
        var maxPos = t.scrollWidth - t.clientWidth;
        this.setDisabled(this.prevBtn, t.scrollLeft <= 2);
        this.setDisabled(this.nextBtn, t.scrollLeft >= maxPos - 2);
      }

      setDisabled(btn, disabled) {
        btn.classList.toggle('is-disabled', disabled);
        btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        btn.tabIndex = disabled ? -1 : 0;
      }
    }
  );
})();
